import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Container } from "react-bootstrap";
import {
  servicesData,
  Clients,
  carouselImages,
  newsData,
  getPropertyData,
  getPropertyListData,
  testimonialsData,
  inspirehomedata,
  addressInfo,
} from "../Constants/Data";
import Button from "../Components/Button";
import PropertyCard from "../Components/PropertyCard";
import PropertyList from "../Components/PropertyList";
import ServiceCard from "../Components/ServiceCard";

import Profile from "../assets/profile.jpg";
import InspireHome from "../assets/image.png";
import InspireHomeCover from "../assets/22.jpg";
import FallbackImage from "../assets/2.jpg";
import video from "../assets/VIDEO.mp4";

import Image1 from "../assets/4.jpg";
import Image2 from "../assets/5.jpg";
import Image3 from "../assets/6.jpg";
import Image4 from "../assets/7.jpg";
import Image5 from "../assets/8.jpg";
import Image6 from "../assets/9.jpg";
import Image7 from "../assets/10.jpg";
import Image8 from "../assets/11.jpg";

export default function Home() {
  // Property Data
  const [propertiesListData, setPropertyListData] = useState([]);

  useEffect(() => {
    const loadProperties = async () => {
      try {
        const data = await getPropertyListData();

        // Debug logging
        // console.log("Properties loaded:", data);
        // console.log(
        //   "Number of properties:",
        //   Array.isArray(data) ? data.length : 0
        // );

        if (Array.isArray(data) && data.length > 0) {
          // console.log("First property structure:", {
          //   address: data[0]?.address,
          //   hasState: !!data[0]?.address?.state,
          //   stateValue: data[0]?.address?.state,
          // });
        }

        if (!Array.isArray(data)) {
          throw new Error("Invalid property list data format");
        }

        setPropertyListData(data);
      } catch (error) {
        // console.error("Error loading property list:", error.message);
        setPropertyListData([]);
      }
    };

    loadProperties();
  }, []);

  // Group properties by state
  const groupedProperties = (propertiesListData || []).reduce(
    (acc, property) => {
      const state = property?.address?.state?.trim();
      const validState = state && state.length > 0 ? state : "Unknown";

      if (!acc[validState]) {
        acc[validState] = {
          properties: [],
          state: validState,
          // Get first image from first property in state for display
          image: property?.images?.[0]?.path || FallbackImage,
        };
      }

      acc[validState].properties.push(property);
      return acc;
    },
    {},
  );

  // Convert to array
  const groupedPropertiesArray = Object.values(groupedProperties);

  // Debug grouped properties
  useEffect(() => {
    // console.log("Grouped properties array:", groupedPropertiesArray);
    // console.log("Number of states found:", groupedPropertiesArray.length);
  }, [groupedPropertiesArray]);

  // Sliding images state for Real Estate Rental Marketplace section
  const [slidingImages] = useState([
    Image1,
    Image2,
    Image3,
    Image4,
    Image5,
    Image6,
    Image7,
    Image8,
  ]);
  const [currentSlideImageIndex, setCurrentSlideImageIndex] = useState(0);

  // Auto-slide effect for marketplace section images
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlideImageIndex(
        (prevIndex) => (prevIndex + 1) % slidingImages.length,
      );
    }, 4000); // Change image every 4 seconds

    return () => clearInterval(interval);
  }, [slidingImages.length]);

  // Index states for different sections
  const [newsIndex, setNewsIndex] = useState(0);
  const [filterPropertyIndex, setFilterPropertyIndex] = useState(0);
  const [servicesIndex, setServicesIndex] = useState(0);
  const [propertiesIndex, setPropertiesIndex] = useState(0);
  const [propertyListIndex, setPropertyListIndex] = useState(0);
  const [cardsPerRow, setCardsPerRow] = useState(3);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const updateCardsPerRow = () => {
        const width = window.innerWidth;

        if (width < 768) {
          setCardsPerRow(1); // mobile
        } else if (width < 992) {
          setCardsPerRow(2); // tablet / medium
        } else {
          setCardsPerRow(3); // desktop
        }
      };

      updateCardsPerRow();
      window.addEventListener("resize", updateCardsPerRow);

      return () => window.removeEventListener("resize", updateCardsPerRow);
    }
  }, []);

  const totalSlides = Math.ceil(servicesData.length / cardsPerRow);

  // Handle Next Button
  const handleNext = (section) => {
    switch (section) {
      case "news":
        if (newsIndex + cardsPerRow < newsData.length) {
          setNewsIndex(newsIndex + 1);
        }
        break;
      case "services":
        if (servicesIndex + cardsPerRow < servicesData.length) {
          setServicesIndex(servicesIndex + 1);
        }
        break;
      case "properties":
        if (propertiesIndex + cardsPerRow < groupedPropertiesArray.length) {
          setPropertiesIndex(propertiesIndex + 1);
        }
        break;
      case "propertyList":
        if (propertyListIndex + cardsPerRow < propertiesListData.length) {
          setPropertyListIndex(propertyListIndex + 1);
        }
        break;
      case "filteredProperties":
        if (filterPropertyIndex + cardsPerRow < propertiesListData.length) {
          setFilterPropertyIndex(filterPropertyIndex + 1);
        }
        break;
      default:
        break;
    }
  };

  // Handle Prev Button
  const handlePrev = (section) => {
    switch (section) {
      case "news":
        if (newsIndex > 0) {
          setNewsIndex(newsIndex - 1);
        }
        break;
      case "services":
        if (servicesIndex > 0) {
          setServicesIndex(servicesIndex - 1);
        }
        break;
      case "properties":
        if (propertiesIndex > 0) {
          setPropertiesIndex(propertiesIndex - 1);
        }
        break;
      case "propertyList":
        if (propertyListIndex > 0) {
          setPropertyListIndex(propertyListIndex - 1);
        }
        break;
      case "filteredProperties":
        if (filterPropertyIndex > 0) {
          setFilterPropertyIndex(filterPropertyIndex - 1);
        }
        break;
      default:
        break;
    }
  };

  // Testimonial data switching & transition
  const [selectedTestimonial, setSelectedTestimonial] = useState(
    testimonialsData[0],
  );
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const changeTestimonial = (index) => {
    setIsTransitioning(true);
    setTimeout(() => {
      setSelectedIndex(index);
      setIsTransitioning(false);
    }, 500);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const nextIndex = (selectedIndex + 1) % testimonialsData.length;
      changeTestimonial(nextIndex);
    }, 5000);

    return () => clearInterval(interval);
  }, [selectedIndex]);

  // Video Modal
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  // Search bar filter
  const [selectedArea, setSelectedArea] = useState("");
  const [selectedSuburb, setSelectedSuburb] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [selectedReason, setSelectedReason] = useState("");

  const [filteredProperties, setFilteredProperties] = useState([]);
  const [showResults, setShowResults] = useState(false);

  const [uniqueStates, setUniqueStates] = useState([]);
  const [uniquePropertyTypes, setUniquePropertyTypes] = useState([]);
  const [uniqueStatus, setUniqueStatus] = useState([]);
  const [uniqueSuburb, setUniqueSuburb] = useState([]);
  const [uniqueReason, setUniqueReason] = useState([]);

  const visibleFilteredProperties = filteredProperties.slice(
    filterPropertyIndex,
    filterPropertyIndex + cardsPerRow,
  );

  // Extract unique states and property types from properties
  useEffect(() => {
    const states = [
      ...new Set(
        propertiesListData
          .map((property) => property.address?.state)
          .filter(Boolean),
      ),
    ];
    setUniqueStates(states);

    const suburb = [
      ...new Set(
        propertiesListData
          .map((property) => property.address?.suburb)
          .filter(Boolean),
      ),
    ];
    setUniqueSuburb(suburb);

    const propertyTypes = [
      ...new Set(
        propertiesListData.map((property) => property.ptype).filter(Boolean),
      ),
    ];
    setUniquePropertyTypes(propertyTypes);

    const statuses = [
      ...new Set(
        propertiesListData.map((property) => property.pstatus).filter(Boolean),
      ),
    ];
    setUniqueStatus(statuses);

    const reasons = [
      ...new Set(
        propertiesListData.map((property) => property.preason).filter(Boolean),
      ),
    ];
    setUniqueReason(reasons);
  }, [propertiesListData]);

  // Handle search button click
  const handleSearch = () => {
    const filtered = propertiesListData.filter((property) => {
      return (
        (selectedArea ? property.address?.state === selectedArea : true) &&
        (selectedSuburb ? property.address?.suburb === selectedSuburb : true) &&
        (selectedType ? property.ptype === selectedType : true) &&
        (selectedStatus ? property.pstatus === selectedStatus : true) &&
        (selectedReason ? property.preason === selectedReason : true)
      );
    });
    setFilteredProperties(filtered);
    setShowResults(true);
    setFilterPropertyIndex(0); // Reset to first page
  };

  // Inspire home slider
  const [currentArrowIndex, setCurrentArrowIndex] = useState(0);

  const handleArrowNext = () => {
    setCurrentArrowIndex((prevIndex) =>
      prevIndex === inspirehomedata.length - 1 ? 0 : prevIndex + 1,
    );
  };

  const handleArrowPrev = () => {
    setCurrentArrowIndex((prevIndex) =>
      prevIndex === 0 ? inspirehomedata.length - 1 : prevIndex - 1,
    );
  };

  const [description, setDescription] = useState("");

  useEffect(() => {
    setDescription(inspirehomedata?.[currentArrowIndex]?.description || "");
  }, [currentArrowIndex]);

  const [startIndex, setStartIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setStartIndex(
        (prevIndex) => (prevIndex + 1) % propertiesListData.length, // Loops continuously
      );
    }, 5000); // Auto-slide every 5 seconds

    return () => clearInterval(interval);
  }, [propertiesListData.length]);

  const displayedProperties = [
    ...propertiesListData,
    ...propertiesListData, // Duplicate the list to create a smooth loop
  ].slice(startIndex, startIndex + cardsPerRow);

  // Property image slider
  const [images, setImages] = useState([]);
  useEffect(() => {
    const fetchImages = async () => {
      const data = await getPropertyListData();

      if (Array.isArray(data) && data.length > 0) {
        const firstProperty = data[0]; // Get the first property (adjust if necessary)
        if (firstProperty?.images && Array.isArray(firstProperty.images)) {
          setImages(firstProperty.images);
        }
      }
    };
    fetchImages();
  }, []);

  useEffect(() => {
    if (images.length > 0) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, 4000);

      return () => clearInterval(interval);
    }
  }, [images]);

  // Get the current image path
  const currentImage = images[currentIndex]?.path || FallbackImage;

  return (
    <>
      <Helmet>
        {/* Basic SEO */}
        <title>Urban View Real Estate PVT LTD</title>
        <meta
          name="description"
          content="Find affordable homes for sale & rent across Australia with Urban View Real Estate. Explore investment properties in Brisbane, Sydney suburbs, Queensland & Melbourne."
        />
        <meta
          name="keywords"
          content="Affordable Homes for Sale in South Australia, Affordable Homes for Sale in Melbourne, Affordable Homes for Sale in Queensland, Development Sites for Sale in Sydney, Cheap Rent a Home in Penrith, House Buying in Western Australia, Cheap Duplex Home in Tamworth, Affordable duplex Home in Armidale, Houses for Rental in St Marys, Investement Property in Queensland, Best Investment Property Sale in Brisbane, Best Investment Property Sale in Rouse Hill, Box Hill, Marsden Park, Vineyard, Investment Property Buy in Austral, Investment Property Buy in Tallawong, Investment Property Buy in Oran Park, Investment Property Buy in Leppington"
        />

        <meta name="author" content="Urban View Real Estate PVT LTD" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://urbanviewre.com" />

        {/* Open Graph */}
        <meta property="og:title" content="Urban View Real Estate PVT LTD" />
        <meta
          property="og:description"
          content="Find affordable homes for sale & rent across Australia with Urban View Real Estate. Explore investment properties in Brisbane, Sydney suburbs, Queensland & Melbourne."
        />
        <meta property="og:site_name" content="Urban View Real Estate" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://urbanviewre.com" />
        <meta
          property="og:image"
          content="https://urbanviewre.com/assets/logo-2-CGgGTWZk.png"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Urban View Real Estate PVT LTD" />
        <meta
          name="twitter:description"
          content="Find affordable homes for sale & rent across Australia with Urban View Real Estate. Explore investment properties in Brisbane, Sydney suburbs, Queensland & Melbourne."
        />
        <meta
          name="twitter:image"
          content="https://urbanviewre.com/assets/logo-2-CGgGTWZk.png"
        />
        <meta name="twitter:site" content="@urbanviewre" />
        <meta name="twitter:creator" content="@urbanviewre" />

        {/* Facebook  */}
        <meta
          property="fb:admins"
          content="https://www.facebook.com/profile.php?id=61559035348971"
        />

        {/* Instagram */}
        <meta name="instagram:title" content="Urban View Real Estate PVT LTD" />
        <meta
          name="instagram:description"
          content="Find affordable homes for sale & rent across Australia with Urban View Real Estate. Explore investment properties in Brisbane, Sydney suburbs, Queensland & Melbourne."
        />
        <meta name="instagram:site" content="@urbanviewrealestate" />
      </Helmet>

      {/* Hero Section - Single Static Image (Slider 1) */}
      <section
        id="heroSection"
        className="position-relative d-flex flex-column align-items-center justify-content-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url(${carouselImages[0]})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          height: "100vh",
        }}
      >
        <div
          className="carousel-content px-3 text-white position-relative z-2 fadeInTop text-center"
          style={{ maxWidth: "900px" }}
        >
          <h6>Urbanview Real Estate</h6>
          <h1 className="brand fw-bold display-4">
            Find Your Dream <br /> House By Us
          </h1>
          <p className="m-0 py-4">
            We have built strong relationships with reputable developers,
            contractors, and financial institutions to provide you with the best
            options and services.
          </p>
          <Button text="Make an query" className="text-white" href="/contact" />
        </div>

        {/* Carousel Navigation Buttons - Commented Out */}
        {/* 
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#heroCarousel"
          data-bs-slide="prev"
          aria-label="Previous slide"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>

        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#heroCarousel"
          data-bs-slide="next"
          aria-label="Next slide"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
        */}
      </section>

      {/* Search Bar */}
      <section className="slider">
        <div
          className="justify-content-center position-relative"
          style={{ bottom: "80px" }}
        >
          <div className="container">
            <div className="bg-white shadow-sm p-5 d-flex flex-wrap align-items-center justify-content-center text-center">
              <div className="col-lg-2 col-md-6 col-12 px-2 mb-3 mb-lg-0">
                <label htmlFor="propertyState" className="visually-hidden">
                  Property State
                </label>
                <select
                  id="propertyState"
                  className="form-select rounded-0 py-3 w-100"
                  value={selectedArea}
                  onChange={(e) => setSelectedArea(e.target.value)}
                >
                  <option value="">Property State</option>
                  {uniqueStates.map((state, index) => (
                    <option key={index} value={state}>
                      {state}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-lg-2 col-md-6 col-12 px-2 mb-3 mb-lg-0">
                <label htmlFor="propertySuburb" className="visually-hidden">
                  Property Suburb
                </label>
                <select
                  id="propertySuburb"
                  className="form-select rounded-0 py-3 w-100"
                  value={selectedSuburb}
                  onChange={(e) => setSelectedSuburb(e.target.value)}
                >
                  <option value="">Property Suburb</option>
                  {uniqueSuburb.map((suburb, index) => (
                    <option key={index} value={suburb}>
                      {suburb}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-lg-2 col-md-6 col-12 px-2 mb-3 mb-lg-0">
                <label htmlFor="propertyType" className="visually-hidden">
                  Property Type
                </label>
                <select
                  id="propertyType"
                  className="form-select rounded-0 py-3 w-100"
                  value={selectedType}
                  onChange={(e) => setSelectedType(e.target.value)}
                >
                  <option value="">Property Type</option>
                  {uniquePropertyTypes.map((type, index) => (
                    <option key={index} value={type}>
                      {type}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-lg-2 col-md-6 col-12 px-2 mb-3 mb-lg-0">
                <label htmlFor="propertyStatus" className="visually-hidden">
                  Property Status
                </label>
                <select
                  id="propertyStatus"
                  className="form-select rounded-0 py-3 w-100"
                  value={selectedStatus}
                  onChange={(e) => setSelectedStatus(e.target.value)}
                >
                  <option value="">Property Status</option>
                  {uniqueStatus.map((status, index) => (
                    <option key={index} value={status}>
                      {status}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-lg-2 col-md-6 col-12 px-2 mb-3 mb-lg-0">
                <label htmlFor="propertyGroup" className="visually-hidden">
                  Property Group
                </label>
                <select
                  id="propertyGroup"
                  className="form-select rounded-0 py-3 w-100"
                  value={selectedReason}
                  onChange={(e) => setSelectedReason(e.target.value)}
                >
                  <option value="">Group</option>
                  {uniqueReason.map((reason, index) => (
                    <option key={index} value={reason}>
                      {reason}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-lg-2 col-md-6 col-12 px-2 d-flex justify-content-lg-center">
                <Button
                  text="FIND NOW"
                  className="text-muted w-100"
                  onClick={handleSearch}
                />
              </div>
            </div>
          </div>

          {/* Property Results Section (Initially Hidden) */}
          {showResults && (
            <div className="mt-5 container position-relative">
              <div className="row">
                {filteredProperties.length > 0 ? (
                  visibleFilteredProperties.map((property) => (
                    <div className="col-md-4 mb-4" key={property.id}>
                      <PropertyList {...property} />
                    </div>
                  ))
                ) : (
                  <p className="text-center text-muted">No properties found.</p>
                )}
              </div>
              {/* Navigation Buttons */}
              <button
                className="carousel-control-prev rounded-circle border position-absolute"
                type="button"
                style={{
                  top: "50%",
                  zIndex: "2",
                  width: "50px",
                  height: "50px",
                }}
                onClick={() => handlePrev("filteredProperties")}
                disabled={filterPropertyIndex === 0}
              >
                <span aria-hidden="true">
                  <i className="bi bi-arrow-left text-dark fs-4"></i>
                </span>
                <span className="visually-hidden">Previous</span>
              </button>

              <button
                className="carousel-control-next rounded-circle border position-absolute"
                type="button"
                style={{
                  top: "50%",
                  zIndex: "2",
                  width: "50px",
                  height: "50px",
                }}
                onClick={() => handleNext("filteredProperties")}
                disabled={
                  filterPropertyIndex + cardsPerRow >= filteredProperties.length
                }
              >
                <span aria-hidden="true">
                  <i className="bi bi-arrow-right text-dark fs-4"></i>
                </span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          )}
        </div>
      </section>

      <Container>
        <section className="py-5">
          <div className="container">
            <div className="row">
              <div className="col-12 col-lg-6 d-flex justify-content-center">
                <div className="bg-light border rounded position-relative overflow-hidden">
                  <img
                    src={slidingImages[currentSlideImageIndex]}
                    alt="Inspire Homes Australia"
                    height={350}
                    className="rounded about-img w-100"
                    style={{
                      objectFit: "cover",
                      transition: "opacity 0.5s ease-in-out",
                    }}
                  />
                </div>
              </div>

              <div className="col-12 col-lg-6 text-center text-md-start">
                <h2 className="fw-bold brand py-3">
                  The Leading Real Estate Rental Marketplace.
                </h2>
                <p className="text-muted mt-3">
                  At UrbanView, our mission is simple: to provide exceptional
                  real estate services that exceed expectations. We are
                  committed to guiding our clients through every step of the
                  buying, selling, or leasing process with professionalism and
                  integrity.
                </p>
                <p className="text-muted mt-3">
                  At UrbanView, we are dedicated to building long-term
                  relationships with our clients. We measure our success by your
                  satisfaction and strive to exceed your expectations in every
                  transaction.
                </p>
              </div>
            </div>
          </div>

          <div className="container py-5">
            <div className="row pt-5 g-4 align-items-stretch justify-content-center">
              {addressInfo.map((item, index) => (
                <div key={index} className="col-12 col-sm-6 col-lg-4 d-flex">
                  <div className="card w-100 h-100 align-items-center rounded-0 text-center border py-5 px-2 service-card">
                    <h5 className="mb-1 fw-bold brand">{item.title}</h5>

                    {item.details.map((detail, i) => (
                      <p key={i} className="py-1 mb-0 fw-semibold text-muted">
                        <i className="bi bi-geo-alt-fill me-2 text-primary"></i>
                        <a
                          href={detail.href}
                          className="text-muted text-decoration-none"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {detail.label}
                        </a>
                      </p>
                    ))}

                    <h6 className="fw-semibold text-muted mt-auto">
                      <i className="bi bi-telephone-fill me-2 text-primary"></i>
                      <a
                        href={`tel:${item.number}`}
                        className="text-muted text-decoration-none"
                        target={item.external ? "_blank" : undefined}
                        rel="noopener noreferrer"
                      >
                        {item.number}
                      </a>
                    </h6>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </Container>

      {/* Services Section */}
      <section className="slider py-5 text-center">
        <div className="container">
          <h6 className="badge text-primary rounded-4 fw-bold px-3 fs-6">
            Our Services
          </h6>
          <h2 className="fw-bold brand py-3">Our Main Focus</h2>
          <div className="mt-5 position-relative">
            <div className="row mt-4 flex-nowrap overflow-hidden justify-content-start align-items-stretch">
              {servicesData
                .slice(servicesIndex, servicesIndex + cardsPerRow)
                .map((service) => (
                  <ServiceCard key={service.id} {...service} />
                ))}
            </div>
            {/* Navigation Buttons */}
            <button
              className="carousel-control-prev rounded-circle border position-absolute"
              type="button"
              style={{
                top: "50%",
                zIndex: "2",
                width: "50px",
                height: "50px",
              }}
              onClick={() => handlePrev("services")}
              disabled={servicesIndex === 0}
              aria-label="Previous"
            >
              <span aria-hidden="true">
                <i
                  className="bi bi-arrow-left text-dark fs-4"
                  aria-hidden="true"
                ></i>
              </span>
              <span className="visually-hidden">Previous</span>
            </button>

            <button
              className="carousel-control-next rounded-circle border position-absolute"
              type="button"
              style={{
                top: "50%",
                zIndex: "2",
                width: "50px",
                height: "50px",
              }}
              onClick={() => handleNext("services")}
              disabled={servicesIndex + cardsPerRow >= servicesData.length}
              aria-label="Next"
            >
              <span aria-hidden="true">
                <i
                  className="bi bi-arrow-right text-dark fs-4"
                  aria-hidden="true"
                ></i>
              </span>
              <span className="visually-hidden">Next</span>
            </button>

            <div
              className="d-flex justify-content-center mt-4"
              role="group"
              aria-label="Services slide navigation"
            >
              {Array.from({ length: Math.min(5, totalSlides) }, (_, index) => {
                const slideIndex = Math.floor(
                  (servicesIndex / cardsPerRow) % totalSlides,
                );
                return (
                  <span
                    key={index}
                    className={`dot ${index === slideIndex ? "active" : ""}`}
                    onClick={() => setServicesIndex(index * cardsPerRow)}
                  ></span>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* Inspire Home Section*/}
      <section
        className="inspire-section py-5"
        style={{
          backgroundImage: `url(${InspireHomeCover})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          position: "relative",
          height: "480px",
        }}
      >
        <div className="container">
          <div
            className="inspire-home position-relative"
          >
            <div className="d-flex align-items-center justify-content-between text-white mb-3">
              <h2 className="fw-bold text-white text-center brand">
                Inspire Homes Australia
              </h2>
              <div className="d-flex gap-3">
                <button
                  className="bg-primary text-white p-2 shadow-md border-0"
                  onClick={handleArrowPrev}
                  aria-label="Previous"
                >
                  <i className="bi bi-chevron-left px-1" aria-hidden="true"></i>
                </button>

                <button
                  className="bg-primary text-white p-2 shadow-md border-0"
                  onClick={handleArrowNext}
                  aria-label="Next"
                >
                  <i
                    className="bi bi-chevron-right px-1"
                    aria-hidden="true"
                  ></i>
                </button>
              </div>
            </div>
           <div className="row bg-white shadow p-3">
  <div
    className="col-12 col-lg-6 d-flex justify-content-center align-items-center position-relative"
    style={{
      background: "linear-gradient(205deg, #2D4551 0%, #0D1F29 100%)",
      height: "350px",
    }}
  >
    <img
      src={InspireHome}
      alt="Inspire Homes Australia"
      className="rounded"
      style={{ objectFit: "cover", width: "100%" }}
    />
  </div>

  <div className="col-12 col-lg-6 d-flex flex-column justify-content-center align-items-start p-3">
    <h4 className="text-muted fw-bold">
      {inspirehomedata[currentArrowIndex]?.title || "Inspire Homes"}
    </h4>
    <p className="text-muted">
      <span dangerouslySetInnerHTML={{ __html: description }} />
    </p>
    <p className="text-muted">
      For expert guidance and a seamless home-building experience,
      <br />
      call us today on 02 4701 4550!
    </p>
  </div>
</div>
          </div>
        </div>
      </section>

      {/* Property Section - FIXED */}
      <section className="bg-light slider py-5 mt-5 mt-md-0">
        <div className="container text-center mt-5 pt-5">
          <h6 className="badge text-primary rounded-4 fw-bold px-3 fs-6">
            Area Properties
          </h6>
          <h2 className="fw-bold brand py-3">Properties By Location</h2>

          {/* Debug info - remove in production */}
          {process.env.NODE_ENV === "development" &&
            groupedPropertiesArray.length === 0 &&
            propertiesListData.length > 0 && (
              <div className="alert alert-warning my-3">
                <small>
                  Debug: {propertiesListData.length} properties loaded but not
                  grouped. Check if properties have address.state field.
                </small>
              </div>
            )}

          <div className="mt-5 position-relative">
            <div className="row">
              {groupedPropertiesArray.length > 0 ? (
                groupedPropertiesArray
                  .slice(
                    propertiesIndex,
                    Math.min(
                      propertiesIndex + cardsPerRow,
                      groupedPropertiesArray.length,
                    ),
                  )
                  .map(({ state, properties, image }) => {
                    if (!properties || properties.length === 0) return null;

                    return (
                      <div
                        className="col-12 col-md-6 col-lg-4 mb-4"
                        key={state}
                      >
                        <PropertyCard
                          images={image ? [{ path: image }] : []}
                          propertiesCount={properties.length}
                          address={{ state }}
                          ptitle={`Properties in ${state}`}
                          link={`/properties?state=${encodeURIComponent(state)}`}
                        />
                      </div>
                    );
                  })
              ) : propertiesListData.length > 0 ? (
                <div className="alert alert-info">
                  <p>
                    Showing individual properties (grouping by state not
                    available)
                  </p>
                  <div className="row">
                    {propertiesListData
                      .slice(
                        0,
                        Math.min(cardsPerRow, propertiesListData.length),
                      )
                      .map((property, index) => (
                        <div
                          className="col-12 col-md-6 col-lg-4 mb-4"
                          key={property.id || index}
                        >
                          <PropertyCard
                            images={property?.images || []}
                            propertiesCount={1}
                            address={property.address || {}}
                            ptitle={property.ptitle || "Property"}
                            link={`/properties/${property.id}`}
                          />
                        </div>
                      ))}
                  </div>
                </div>
              ) : (
                <p className="text-muted">No properties available</p>
              )}
            </div>

            {/* Navigation Buttons - Only show if there are more items */}
            {groupedPropertiesArray.length > cardsPerRow && (
              <>
                <button
                  className="carousel-control-prev rounded-circle border position-absolute"
                  type="button"
                  style={{
                    top: "50%",
                    left: "-25px",
                    zIndex: "2",
                    width: "50px",
                    height: "50px",
                  }}
                  onClick={() => handlePrev("properties")}
                  disabled={propertiesIndex === 0}
                  aria-label="Previous"
                >
                  <span aria-hidden="true">
                    <i
                      className="bi bi-arrow-left text-dark fs-4"
                      aria-hidden="true"
                    ></i>
                  </span>
                  <span className="visually-hidden">Previous</span>
                </button>

                <button
                  className="carousel-control-next rounded-circle border position-absolute"
                  type="button"
                  style={{
                    top: "50%",
                    right: "-25px",
                    zIndex: "2",
                    width: "50px",
                    height: "50px",
                  }}
                  onClick={() => handleNext("properties")}
                  disabled={
                    propertiesIndex + cardsPerRow >=
                    groupedPropertiesArray.length
                  }
                  aria-label="Next"
                >
                  <span aria-hidden="true">
                    <i
                      className="bi bi-arrow-right text-dark fs-4"
                      aria-hidden="true"
                    ></i>
                  </span>
                  <span className="visually-hidden">Next</span>
                </button>
              </>
            )}
          </div>
        </div>
      </section>

      {/* featured list Section */}
      <section className="slider py-5">
        <div className="container text-center">
          <h6 className="badge text-primary rounded-4 fw-bold px-3 fs-6">
            Properties
          </h6>
          <h2 className="fw-bold brand py-3">Featured Listings</h2>
          <div className="mt-5 position-relative">
            <div className="row d-flex justify-content-center align-items-stretch">
              {propertiesListData.length > 0 ? (
                propertiesListData
                  .slice(propertyListIndex, propertyListIndex + cardsPerRow)
                  .map((property, index) => (
                    <div
                      className="col-12 col-md-6 col-lg-4 mb-4 d-flex justify-content-center"
                      key={property.id || index}
                    >
                      <PropertyList {...property} className="flex-fill" />
                    </div>
                  ))
              ) : (
                <p className="text-muted">No featured properties available</p>
              )}
            </div>

            {/* Navigation Buttons */}
            {propertiesListData.length > cardsPerRow && (
              <>
                <button
                  className="carousel-control-prev rounded-circle border position-absolute"
                  type="button"
                  style={{
                    top: "50%",
                    left: "-25px",
                    zIndex: "2",
                    width: "50px",
                    height: "50px",
                  }}
                  onClick={() => handlePrev("propertyList")}
                  disabled={propertyListIndex === 0}
                  aria-label="Previous"
                >
                  <span aria-hidden="true">
                    <i
                      className="bi bi-arrow-left text-dark fs-4"
                      aria-hidden="true"
                    ></i>
                  </span>
                  <span className="visually-hidden">Previous</span>
                </button>

                <button
                  className="carousel-control-next rounded-circle border position-absolute"
                  type="button"
                  style={{
                    top: "50%",
                    right: "-25px",
                    zIndex: "2",
                    width: "50px",
                    height: "50px",
                  }}
                  onClick={() => handleNext("propertyList")}
                  disabled={
                    propertyListIndex + cardsPerRow >= propertiesListData.length
                  }
                  aria-label="Next"
                >
                  <span aria-hidden="true">
                    <i
                      className="bi bi-arrow-right text-dark fs-4"
                      aria-hidden="true"
                    ></i>
                  </span>
                  <span className="visually-hidden">Next</span>
                </button>
              </>
            )}
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section>
        <div className="parallax d-flex align-items-center justify-content-center">
          <div className="z-2">
            <button
              className="play-button d-flex align-items-center justify-centent-conter"
              onClick={handleOpenModal}
              aria-label="Play video"
            >
              <i className="bi bi-play-fill fs-1"></i>
            </button>
          </div>
        </div>

        {/* Video Modal */}
        {isModalOpen && (
          <div
            className="video-modal position-fixed top-0 w-100 h-100 d-flex justify-content-center align-items-center"
            onClick={handleCloseModal} // Clicking outside closes modal
            role="dialog"
            aria-modal="true"
            aria-label="Video player"
          >
            <div
              className="video-container position-relative bg-dark p-3 rounded-3"
              onClick={(e) => e.stopPropagation()} // Prevents closing when clicking inside
            >
              <button
                className="close-btn"
                onClick={handleCloseModal}
                aria-label="Close video"
              >
                <i className="bi bi-x"></i>
              </button>
              <video
                width="100%"
                height="450"
                controls
                autoPlay
                muted
                className="rounded-3"
              >
                <source src={video} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        )}
      </section>

      {/* Testimonials Section */}
      <section className="py-5">
        <div className="container text-center">
          <h6 className="badge text-primary rounded-4 fw-bold px-3 fs-6">
            Our Testimonial
          </h6>
          <h2 className="fw-bold brand py-3">Clients Feedback</h2>
          <div className="row align-items-center">
            <div className="col-md-12 text-center">
              <div
                className={`position-relative mt-4 fade-transition ${
                  isTransitioning ? "fade-out" : "fade-in"
                }`}
              >
                <div className="p-2">
                  <img
                    src={testimonialsData[selectedIndex]?.image || Profile}
                    alt={testimonialsData[selectedIndex]?.name || "Client"}
                    className="rounded-circle shadow-sm"
                    onError={(e) => (e.target.src = Profile)}
                    style={{ width: "90px", height: "90px" }}
                  />
                </div>
                <p
                  className="text-muted mx-auto mt-3"
                  style={{ maxWidth: "600px" }}
                >
                  <i className="bi bi-quote text-primary fs-2"></i>{" "}
                  {testimonialsData[selectedIndex]?.feedback ||
                    "No feedback available"}
                </p>
                <h4 className="fw-bold brand">
                  {testimonialsData[selectedIndex]?.name || "Client Name"}
                </h4>
                <p className="text-primary fw-semibold">
                  {testimonialsData[selectedIndex]?.role || "Client"}
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial Indicators */}
          <div className="d-flex justify-content-center mt-4">
            {testimonialsData.map((_, index) => (
              <button
                key={index}
                className={`mx-1 p-0 border-0 bg-transparent ${
                  selectedIndex === index ? "text-primary" : "text-muted"
                }`}
                onClick={() => changeTestimonial(index)}
                aria-label={`Go to testimonial ${index + 1}`}
              >
                <i className="bi bi-circle-fill fs-6"></i>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Partners */}
      <section className="bg-light py-5">
        <div className="client-logos d-flex overflow-hidden position-relative py-5">
          {/* <div className="logo-wrapper d-flex">
            {Clients.concat(Clients).map((imageSrc, index) => (
              <img
                src={imageSrc}
                alt={`Client Logo ${index + 1}`}
                key={`client-${index}`}
                className="client-logo"
              />
            ))}
          </div> */}
        </div>
      </section>

      {/* News Section - Optional */}
      {/* <section className="slider py-5 mb-5 text-center">
        <div className="container">
          <h6 className="badge text-primary rounded-4 fw-bold px-3 fs-6">
            News & Blogs
          </h6>
          <h2 className="fw-bold brand py-3">Latest News Feeds</h2>
          <div className="mt-5 position-relative">
            <div className="row">
              {newsData
                .slice(newsIndex, newsIndex + cardsPerRow)
                .map((news) => (
                  <div className="col-md-4 mb-4" key={news.id}>
                    <NewsCard {...news} />
                  </div>
                ))}
            </div>

            <button
              className="carousel-control-prev rounded-circle border position-absolute"
              type="button"
              style={{
                top: "50%",
                zIndex: "2",
                width: "50px",
                height: "50px",
              }}
              onClick={() => handlePrev("news")}
            >
              <span aria-hidden="true">
                <i className="bi bi-arrow-left text-dark fs-4"></i>
              </span>
              <span className="visually-hidden">Previous</span>
            </button>

            <button
              className="carousel-control-next rounded-circle border position-absolute"
              type="button"
              style={{
                top: "50%",
                zIndex: "2",
                width: "50px",
                height: "50px",
              }}
              onClick={() => handleNext("news")}
            >
              <span aria-hidden="true">
                <i className="bi bi-arrow-right text-dark fs-4"></i>
              </span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </div>
      </section> */}
    </>
  );
}
